<app-toolbar [hidden]="!statusDetail.isLoading">
  <gs-skeleton-loader width="50" height="300"></gs-skeleton-loader>
</app-toolbar>